import React from "react";
import { Tag, Empty, Statistic, Row, Col } from "antd";
import {
    CheckCircleOutlined,
    CloseCircleOutlined,
    ClockCircleOutlined,
    DatabaseOutlined,
    ThunderboltOutlined,
} from "@ant-design/icons";

const statusColors = {
    success: "green",
    failed: "red",
    pending: "gold",
    running: "blue",
    never_executed: "default",
};

export default function ViewInsights({ view }) {
    if (!view) {
        return (
            <div className="flex flex-col h-full p-4">
                <h3 className="text-sm font-semibold mb-2">View Insights</h3>
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Select a view to see insights"
                />
            </div>
        );
    }

    return (
        <div className="flex flex-col h-full p-4">
            <div className="flex items-center justify-between mb-3">
                <h3 className="text-sm font-semibold m-0">{view.viewName}</h3>
                <Tag color={statusColors[view.status] || "default"}>{view.status}</Tag>
            </div>

            {view.description && (
                <p className="text-xs text-gray-500 mb-3">{view.description}</p>
            )}

            <Row gutter={[16, 16]} className="mb-3">
                <Col span={8}>
                    <Statistic
                        title={<span className="text-xs">Records</span>}
                        value={view.recordCount || 0}
                        prefix={<DatabaseOutlined />}
                        valueStyle={{ fontSize: "16px" }}
                    />
                </Col>
                <Col span={8}>
                    <Statistic
                        title={<span className="text-xs">Exec Time</span>}
                        value={view.executionTimeMs ? `${(view.executionTimeMs / 1000).toFixed(1)}s` : "N/A"}
                        prefix={<ThunderboltOutlined />}
                        valueStyle={{ fontSize: "16px" }}
                    />
                </Col>
                <Col span={8}>
                    <Statistic
                        title={<span className="text-xs">Steps</span>}
                        value={view.pipelineStepsSnapshot ? view.pipelineStepsSnapshot.length : 0}
                        prefix={<ClockCircleOutlined />}
                        valueStyle={{ fontSize: "16px" }}
                    />
                </Col>
            </Row>

            <div className="text-xs space-y-1.5">
                <div className="flex justify-between">
                    <span className="text-gray-500">Pipeline</span>
                    <span>{view.pipelineId || "None"}</span>
                </div>
                <div className="flex justify-between">
                    <span className="text-gray-500">Source Dataset</span>
                    <span className="truncate ml-2">{view.sourceDatasetId}</span>
                </div>
                <div className="flex justify-between">
                    <span className="text-gray-500">Last Executed</span>
                    <span>{view.lastExecuted ? new Date(view.lastExecuted).toLocaleString() : "Never"}</span>
                </div>
                <div className="flex justify-between">
                    <span className="text-gray-500">Created By</span>
                    <span>{view.createdByName}</span>
                </div>
                {view.isAutoGenerated && (
                    <div className="mt-2">
                        <Tag color="purple" className="text-xs">Pipeline Output (Auto-generated)</Tag>
                    </div>
                )}
            </div>
        </div>
    );
}
